/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Approval_DescriptionInputs */



/**
* | output |
* | --- |
* | "This run paused before an action that needs a human decision." |
*
* @param {Agent_Run_Approval_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_approval_description = /** @type {((inputs?: Agent_Run_Approval_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Approval_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Lauf pausierte vor einer Aktion, die eine menschliche Entscheidung erfordert.")
	return /** @type {LocalizedString} */ ("This run paused before an action that needs a human decision.")
});